import { render } from "./vcurriculumclassify.vue?vue&type=template&id=63a0ada2&scoped=true"
import script from "./vcurriculumclassify.vue?vue&type=script&lang=js"
export * from "./vcurriculumclassify.vue?vue&type=script&lang=js"

import "./vcurriculumclassify.vue?vue&type=style&index=0&id=63a0ada2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a0ada2"]])

export default __exports__